import React, { useEffect, useState } from 'react';
import SelectMenu from '../common/SelectMenu';
import { useDispatch, useSelector } from 'react-redux';
import { getReportTypes, uploadCarrierReport } from '../../store/actions';
import Trash from "../../assets/trashRed.svg";
import { toast } from "react-toastify";
import ProcessReview from './ProcessReview';
import { allowedCSVExtension } from '../../constant';
import LoaderSpinner from '../common/Loader';

const CarrierReport = () => {
    const { reportTypes } = useSelector((state) => state?.batchReducer);
    const [moduleList, setModuleList] = React.useState([]);
    const dispatch = useDispatch();

    const [formData, setFormData] = React.useState({
        module: null,
        template: null,
        chooseFile: null,
    });
    const [File, setFile] = useState();
    const [fileName, setFileName] = useState("");
    const [showProcessDialog, setShowProcessDialog] = useState(false);
    const [showLoader, setShowLoader] = useState(false);
    useEffect(() => {
        if (reportTypes.length > 0) {
            let modules = reportTypes?.map(item => ({ label: item.reportType, value: item.reportTypeId }));
            setModuleList(modules);
        } else {
            dispatch(getReportTypes());
        }
    }, [reportTypes]);

    const handleModuleChange = (value) => {
        setFormData({ ...formData, module: value, template: null });
    };

    const onTrashClick = () => {
        setFileName(null);
        setFile(null);
    };

    const handleUploadClick = (event) => {
        if (event.target.files?.[0]) {
            const file = event.target.files[0];
            const extension = file.name.split(".").slice(-1).pop();
            if (!allowedCSVExtension.includes(extension ? extension.toLowerCase() : "")) {
                toast.error('Please select CSV file only');
                // Clear the input
                event.target.value = '';
                return;
            } else {
                setFile(file);
                setFileName(file.name);
            }
        }
    };

    const handleUpload = async () => {
        setShowLoader(true);
        try {
            let formDataPayload = new FormData();
            formDataPayload.append("csvFile", File);
            let res = await uploadCarrierReport(formDataPayload, formData?.module?.value);
            
            // Handle new response format
            if (res?.data?.Status === 200) {
                // Check for new format first
                if (res.data.Entity?.FileName) {
                    // CSV file URL available - open in new window
                    window.open(res.data.Entity.FileName, '_blank');
                    setFileName(null);
                    setFile(null);
                    toast.success('File Uploaded Successfully');
                } else if (res.data.Entity?.TransactionReports) {
                    // Transaction reports available - could add table display here if needed
                    toast.info('Transaction report data received. Use Process Review for detailed view.');
                } else {
                    toast.info('File Processed Successfully.');
                }
                return;
            } else {
                const errorMessage = res?.data?.message || res?.data?.Message?.AppStatusDescription || 'Something went wrong';
                toast.error(errorMessage);
            }
        } catch (error) {
            toast.error('An error occurred while uploading the file');
        } finally {
            setShowLoader(false);
        }
    };

    const handleShowProcessDialog = () => {
        setShowProcessDialog(true);
    };

    return (
        <main>
            <div className="main__container">
                <div className="main__tile_heading cus-btn-include-sec">Process Review
                    <div className='top_right_button_container'>
                        <button disabled={showLoader} className="btn cus-seconday-bg-btn marginLeft5 cancelBtn" onClick={handleShowProcessDialog}>Process Review File</button>
                        <button className="btn cus-primary-transparent-btn ml-2" onClick={() => window.history.back()}>Back</button>
                    </div>
                </div>
                {showLoader && <LoaderSpinner />}
                <div className="container-fluid">
                    <div className="cus-page-content-sec">
                        <div className="content-container pt-5 fontFix">
                            <div className="row">
                                <div className='col-12'>
                                    <div className='row mb-3'>
                                        <div className="col-sm-12 col-lg-4 formLabel pt-2 alignRight">Select Report Type</div>
                                        <div className="col-sm-12 col-lg-6">
                                            <div className={"select_react_Csv"}>
                                                <SelectMenu
                                                    optionList={moduleList}
                                                    handleChange={(value) => { handleModuleChange(value) }}
                                                    placeholderText={'Select Report Type'}
                                                    value={formData.module}
                                                    name='moduleList'
                                                    isMulti={false}
                                                    classPrefix="moduleList"
                                                    closeMenuOnSelect={true}
                                                />
                                            </div>
                                            <p className='helpTxt mt-2'>**Upload corresponding report CSV from carrier website</p>
                                        </div>
                                    </div>
                                    <div className="row flexCenter">
                                        <div className="col-sm-12 col-lg-4 formLabel alignRight">Select File</div>
                                        <div className='col-sm-12 col-lg-6'>
                                            {fileName ? (
                                                <div>
                                                    {fileName}
                                                    <span className="trash-icon">
                                                        {" "}
                                                        <button
                                                        onClick={onTrashClick}
                                                        aria-label="Remove selected file"
                                                        style={{
                                                            background: 'none',
                                                            border: 'none',
                                                            padding: 0,
                                                            cursor: 'pointer',
                                                            display: 'inline-block',
                                                            lineHeight: 0
                                                        }}
                                                    >
                                                        <img
                                                            className="trash-Img"
                                                            src={Trash}
                                                            alt=""
                                                            style={{ pointerEvents: 'none' }}
                                                        />
                                                    </button>
                                                    </span>
                                                </div>
                                            ) : (
                                                <>
                                                    <button className="btn-input-csv">
                                                        <label className="btn-chooseFile" htmlFor={`actual-btn-6`}>
                                                            <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                width="16"
                                                                height="16"
                                                                fill="currentColor"
                                                                className="bi bi-upload"
                                                                viewBox="0 0 16 16"
                                                                cursor="pointer"
                                                            >
                                                                <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                                                                <path d="M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708l3-3z" />
                                                            </svg>{" "}
                                                            &nbsp; Choose File{" "}
                                                        </label>
                                                    </button>
                                                    <input
                                                        type="file"
                                                        name="file"
                                                        accept=".csv"
                                                        id={`actual-btn-6`}
                                                        onChange={(e) => {
                                                            handleUploadClick(e);
                                                        }}
                                                        hidden
                                                    />
                                                </>
                                            )}
                                        </div>
                                    </div>
                                    <div className="row flexCenter mt-3">
                                        <div className="col-sm-12 col-lg-4 formLabel alignRightRes"></div>
                                        <div className='col-sm-12 col-lg-6'>
                                            <button
                                                onClick={handleUpload}
                                                className='btn cus-seconday-bg-btn cancelBtn'
                                                disabled={!File || !formData?.module?.value || showLoader}
                                            >
                                                Upload File
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {showProcessDialog && (
                    <ProcessReview 
                        showLoader={showLoader} 
                        setShowLoader={setShowLoader} 
                        toast={toast} 
                        show={showProcessDialog} 
                        handleCancel={() => setShowProcessDialog(false)} 
                        selectedModule={formData?.module}
                    />
                )}
            </div>
        </main>
    );
}

export default CarrierReport;